module.exports = __webpack_public_path__ + "e244b6eef0d523ebba5a176247a0d16f.MP3";